<template>
    <div>
        物料名称：
        <input type="text" placeholder="物料编号">
        <button>查询</button>

        行:
        <select  v-model="initHang">
            <option v-for="item of hang" :key='item'>{{item}}</option>
        </select>

        列:
        <select  v-model="initLie">
            <option v-for="items of lie" :key='items'>{{items}}</option>
        </select>

        <button @click="HandleClick()">查询</button>
    </div>
</template>

<script>
export default {
    name:'',
    data(){
        return{
            initHang:1,     //默认第一行
            hang:[1,2,3,4,5,6,7,8,9],
            initLie:1,      //默认第一列
            lie:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19],
            huojia:[
                {   
                    number:1,
                    hang:1,
                    lie:1
                },
                {   
                    number:1,
                    hang:1,
                    lie:2
                },
            ]
        }
    },
    methods:{
        HandleClick(){
            console.log(this.initHang);
            console.log(this.initLie);
        }
    },
    mounted(){

    },
    watch(){

    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/xiayan/home/demo.vue